/** @format */

export interface IScoreCardSkuResponse {
  points: number;
  sku: number;
}
